module.exports = __webpack_public_path__ + "media/torsten2.44ebcd07.mp3";